<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row >
        <b-col class="mt-3">
          <h4 style="text-align: center;">Printer Lists</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item class="items-warpper mt-3 mb-3">
              <b-row>
                <b-col cols="5">
                  <b-form-input v-model="macaddress" placeholder="Add Printer Location: MAC Address"></b-form-input>
                </b-col>
                <b-col cols="3">
                  <b-form-input v-model="format" list="formats" placeholder="Format"></b-form-input>
                  <datalist id="formats">
                    <option v-for="format in formats" :key="format.id">{{ format.name }}</option>
                  </datalist>
                </b-col>
                <b-col cols="4">
                  <b-form-input v-model="location" list="locations" placeholder="Location"></b-form-input>
                  <datalist id="locations">
                    <option v-for="location in locations" :key="location.id">{{ location.name }}</option>
                  </datalist>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="11"><b-button class='add-btn' variant="outline-dark" @click="addPrinterLocation()">+</b-button></b-col>
              </b-row>
              <b-row>
                <b-col cols="10"><b-alert v-if="macaddressalert" variant="info" v-model="macaddressalert" dismissible>Please Enter A Printer MAC Address!</b-alert></b-col>
              </b-row>
              <b-row>
                <b-col cols="10"><b-alert v-if="formatalert" variant="info" v-model="formatalert" dismissible>Please Select A Format!</b-alert></b-col>
              </b-row>
              <b-row>
                <b-col cols="10"><b-alert v-if="locationalert" variant="info" v-model="locationalert" dismissible>Please Select A Location!</b-alert></b-col>
              </b-row>
            </b-list-group-item >
              <PrinterLocations
                v-for="printerlocation of printerlocations"
                v-bind:printerlocation="printerlocation"
                v-bind:key="printerlocation.id"
                :printerlocations="printerlocations"
                :categories="categories"
                :locations="locations"
                @emit-switch-overlay="switchOverlay"
                @emit-fetch-printerlocations="fetchPrinterLocations">
              </PrinterLocations>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="currentPage" :total-rows="total_printerlocations" :per-page="limit" align="center" @change="showoverlay=true; fetchPrinterLists()"></b-pagination>
          <p style="text-align: center;">Total Printer Location Lists: {{ total_printerlocations }}</p>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import PrinterLocations from '@/components/PrinterLocations.vue'
export default {
  name: "Printers",
  components: {
    PrinterLocations
  },
  data() {
    return {
      printerlocations: [],
      locations: [],
      categories: [],
      total_printerlocations: 0,
      limit: 25,
      currentPage: 1,
      showoverlay: false,
      macaddress: '',
      format: '',
      location: '',
      macaddressalert: false,
      formatalert: false,
      locationalert: false,
      formats: [{name: "Kitchen Tickets", id: 1},{name: "Receipts", id: 2},{name: "All", id: 3},{name: "Check", id: 4} ]
    };
  },

  computed: {
    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage+"&limit="+this.limit;
    }
  },

  methods: {
    switchOverlay(bool) {
      this.showoverlay = bool;
    },


  async retrieveAllLocations() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      // Check to see if there items associated with this Category?
      try{
      const { data } = await this.$api.get('locations', {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      if (data.success == true) {
        this.locations = data.locations;
        this.switchOverlay(false);
      }
      }
      catch{
        this.$bvModal.msgBoxOk('There was a problem getting locations, please try again later.', {
                  title: 'Error getting locations',
                  centered: true
                })
      }
    },

  async retrieveAllCategory() {
      // Get the access token from the auth wrapper
      try{
      const token = await this.$auth.getTokenSilently();
      // Check to see if there items associated with this Category?
      const { data } = await this.$api.get('categories', {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      if (data.success == true) {
        this.categories = data.categories;
        this.totalcategories = data.totalcategories;
        this.switchOverlay(false);
      }
      }
      catch{
        this.$bvModal.msgBoxOk('There was a problem getting categories, please try again later.', {
          title: 'Error getting categories',
          centered: true
        })
      }
    },

    async addPrinterLocation() {
      if (this.macaddress == '') {
        this.macaddressalert = true;
        return;
      }
      if (this.format == '') {
        this.formatalert = true;
        return;
      }
      if (this.location == '') {
        this.locationalert = true;
        return;
      }
      this.showoverlay=true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };

      const res1 = this.formats.filter(i => i.name == this.format);
      var formatID = res1[0].id;

      const res2 = this.locations.filter(i => i.name == this.location);
      var locationID = res2[0].id;

      var body = {
        "mac": this.macaddress,
        "format": formatID,
        "locationid": locationID
      }
      // alert(JSON.stringify(body));
      // update order with status of 'ready'
      try{
      const { data } = await this.$api.post('printerlocations',
        body,
        config
      );
      if (data.created == true) {
        this.newmacaddress = '';
        this.fetchPrinterLocations();
      } else {
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the printer location, please try again later.', {
          title: 'Error adding printer location',
          centered: true
        })
      }
      }
      catch{
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the printer location, please try again later.', {
          title: 'Error adding printer location',
          centered: true
        })
      }
    },

    async fetchPrinterLocations() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      //alert("GET DATA NOW!!!");

      try {
      // Use Axios to make a call to the API
      const { data } = await this.$api.get("printerlocations", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
        });      
        this.printerlocations = await data.printerlocations;
        this.total_printerlocations = data.total_printerlocations;
        this.showoverlay = false;
      } catch(e) {
        this.$bvModal.msgBoxOk('There was a problem getting printer locations, please try again later.', {
          title: 'Error getting printer locations',
          centered: true
        })
        this.showoverlay = false;
      }
    },

  },

  created: function() {
    // this.showoverlay = true;
    this.fetchPrinterLocations();
    this.retrieveAllLocations();
    this.retrieveAllCategory();
  }
}
</script>
